/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { Navigate, useRoutes, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useAppSelector } from 'store/hooks'
/**********************************************************************************************************
 *   COMPONENT IMPORTS
 **********************************************************************************************************/
import { Frame, Theme } from '@nexigendigital/nxui'
import { setCartOpen } from 'store/slices/shopSlice'

/**********************************************************************************************************
 *    ROUTES
 **********************************************************************************************************/
import Login from 'containers/login/login'
import Shop from 'containers/shop/shop'
import Cart from 'containers/shop/cart/lightbox/cart'

/**********************************************************************************************************
 *   STYLING
 **********************************************************************************************************/
import styled from 'styled-components'

const GuestRoute = {
    Frame: styled(Frame)`
        ${(props) => Theme.Functions.mediaBreakDown(props.theme['breakpoints-lg'])} {
            margin-top: 0;
        }
     `,
    Render: styled.div`
        display: flex;
        height: 100%;
        width: 100%;
    `
}

/**********************************************************************************************************
 *   COMPONENT START
 *****************************************************33*****************************************************/
export default function GuestRouter() {
    const dispatch = useDispatch()
    const location = useLocation()
    const { provider: { application_name, logo_url } } = useAppSelector((state) => state.app.appSettings)

    function getHeader() {
        return location.pathname === '/shop'
            ? {
                src: logo_url,
                alt: application_name
            }
            : false
    }

    return (
        <>
            <GuestRoute.Frame
                guest
                shop={{
                    action: () => dispatch(setCartOpen(true))
                }}
                header={getHeader()}
                location={location}
                content={{
                    render: <GuestRoute.Render>
                        {useRoutes([
                            { path: '/', element: <Navigate to='/login' replace /> },
                            { path: 'login/*', element: <Login /> },
                            { path: 'tos/*', element: <Navigate to='/login' replace /> },
                            { path: '*', element: <Navigate to='/login' replace /> },
                            { path: 'shop/*', element: <Shop /> }
                        ])}
                    </GuestRoute.Render>
                }}
            />
            <Cart />
        </>
    )
}
